import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import ataEncaminhamentosService from "services/AtaEncaminhamentosService";
import { SignOut, Trash } from "@phosphor-icons/react";

const DeleteLoginImageModal = ({ show, onCloseClick, onDeleteClick, data }) => {
	return (
		<Modal
			size="sm"
			isOpen={show}
			toggle={onCloseClick}
			centered={true}
			style={{ minWidth: 700 }}
		>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16">
						Tem certeza que deseja excluir a imagem?
					</p>

					<img
						src={data?.name}
						style={{
							width: 250,
							height: 250,
							objectFit: "cover",
							borderRadius: 5,
						}}
					/>

					<div className="hstack gap-2 justify-content-center mb-0 mt-4">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={() => onDeleteClick(data.id)}
						>
							<Trash size={16} /> Excluir
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

DeleteLoginImageModal.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	onDeleteClick: PropTypes.func,
	data: PropTypes.any,
};

export default DeleteLoginImageModal;
